var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-card',{staticStyle:{"min-height":"400px","margin-bottom":"20px","padding":"20px 0px 20px 0px","text-align":"center"},attrs:{"shadow":"never"}},[_c('font',{staticStyle:{"font-size":"30px","color":"#dddddd"}},[_c('b',[_vm._v("◔ ‸◔？")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4563ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/License.vue
// module id = null
// module chunks = 